module.exports = __webpack_public_path__ + "static/media/sf-test-3.a4b8612c.mp3";